<template>
	<div>

		<div>
			<div class="neirong_ad_image" v-for="(item, index) in detail_adver.list_image" :key="index" style="margin-top: 10px; margin-bottom: 20px;">
				<el-image @click="toUrl(item.url)" :src="$common.adimgUrl + item.img" fit="contain" style="width: 100%;"></el-image>
			</div>
			
		</div>


		<!-- <div class="neirong_right_header">
			<div class="neirong_right_header_title">内容推荐</div>
		</div>
		
		<div>
			<div class="neirong_ad_title" v-for="(item, index) in detail_adver.list_text" :key="index">
				<span @click="toUrl(item.url)">{{item.title}}</span>
			</div>
		</div> -->
		
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				detail_adver: {'list_text': [], 'list_image': []},
			}
		},
		
		created() {
			
		},
		
		mounted() {
			this.loadMenu('10081', 'detail_adver')
		},
		
		methods: {
			// 加载菜单下配置数据
			loadMenu(config_id, return_obj) {
				let url = this.$common.apiUrl + 'pub_web_config/detail/' + config_id
				this.$axios.get(url).then((res) => {
					let list = eval('(' + res.data.data.configJson + ')')
					if (return_obj == 'detail_adver') {
						this.detail_adver = list
						// console.log(this.detail_adver)
					}
				})
			},
			
			// web配置数据链接跳转
			toUrl(url) {
				console.log(url)
				if (url.indexOf('http') > -1) {
					// location.href = url
					window.open(url, '_blank');
				} else {
					this.$router.push({path: url})
					setTimeout(()=>{
						location.reload()
					}, 300)
				}
			},
			
			
		}
	}
</script>

<style>
</style>